import { Injectable } from '@angular/core';
import { NetMask } from '@modules/network/ipv4/interfaces/ipv4-interfaces';
import {
  DateRange,
  HttpMethod,
  ModalStatus,
  Status,
} from '@shared/interfaces/utility.interface';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Setiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  deviceModels = [
    'RB749',
    'RB3011UiAS',
    'TL-ER5120',
    'TL-ER5119',
    'RocketM5',
    'NanoStationM5',
    'LiteBeamM5',
    'PowerBeam5AC400 ISO',
    'PowerBeamM5400',
    'NanoBridgeM5',
    'LiteAP AC',
    'NanoBridgeM5400',
    'NanoBeamM5',
    'PowerBeam5AC400',
    'LiteAPAC',
    'Rocket5ACLite',
    'AirGrid M5HP',
    'PowerBeamM5300',
    'LiteBeam5AC Gen2',
    'AirgridM5Hp',
    'AirFiber5XHD',
    'NanoBeamM5400',
    'Bullet M2',
    'PowerBeam5AC 500 ISO',
  ];

  deviceBrands = ['MIKROTIK', 'UBIQUITI'];

  typesOfDeviceUse = ['ISP', 'CLIENTE'];

  netMasks: NetMask[] = [
    { decimal: '255.255.255.255', cidr: 32, ipsAvailable: 1, hosts: null },
    { decimal: '255.255.255.254', cidr: 31, ipsAvailable: 2, hosts: null },
    { decimal: '255.255.255.252', cidr: 30, ipsAvailable: 4, hosts: 2 },
    { decimal: '255.255.255.248', cidr: 29, ipsAvailable: 8, hosts: 6 },
    { decimal: '255.255.255.240', cidr: 28, ipsAvailable: 16, hosts: 14 },
    { decimal: '255.255.255.224', cidr: 27, ipsAvailable: 32, hosts: 30 },
    { decimal: '255.255.255.192', cidr: 26, ipsAvailable: 64, hosts: 62 },
    { decimal: '255.255.255.128', cidr: 25, ipsAvailable: 128, hosts: 126 },
    { decimal: '255.255.255.0', cidr: 24, ipsAvailable: 256, hosts: 254 },
    { decimal: '255.255.254.0', cidr: 23, ipsAvailable: 512, hosts: 510 },
    { decimal: '255.255.252.0', cidr: 22, ipsAvailable: 1024, hosts: 1022 },
    { decimal: '255.255.248.0', cidr: 21, ipsAvailable: 2048, hosts: 2046 },
    { decimal: '255.255.240.0', cidr: 20, ipsAvailable: 4096, hosts: 4094 },
    { decimal: '255.255.224.0', cidr: 19, ipsAvailable: 8192, hosts: 8190 },
    {
      decimal: '255.255.192.0',
      cidr: 18,
      ipsAvailable: 16384,
      hosts: 16382,
    },
    {
      decimal: '255.255.128.0',
      cidr: 17,
      ipsAvailable: 32768,
      hosts: 32766,
    },
    { decimal: '255.255.0.0', cidr: 16, ipsAvailable: 65536, hosts: 65534 },
    {
      decimal: '255.254.0.0',
      cidr: 15,
      ipsAvailable: 131072,
      hosts: 131070,
    },
    {
      decimal: '255.252.0.0',
      cidr: 14,
      ipsAvailable: 262144,
      hosts: 262142,
    },
    {
      decimal: '255.248.0.0',
      cidr: 13,
      ipsAvailable: 524288,
      hosts: 524286,
    },
    {
      decimal: '255.240.0.0',
      cidr: 12,
      ipsAvailable: 1048576,
      hosts: 1048574,
    },
    {
      decimal: '255.224.0.0',
      cidr: 11,
      ipsAvailable: 2097152,
      hosts: 2097150,
    },
    {
      decimal: '255.192.0.0',
      cidr: 10,
      ipsAvailable: 4194304,
      hosts: 4194302,
    },
    {
      decimal: '255.128.0.0',
      cidr: 9,
      ipsAvailable: 8388608,
      hosts: 8388606,
    },
    {
      decimal: '255.0.0.0',
      cidr: 8,
      ipsAvailable: 16777216,
      hosts: 16777214,
    },
    {
      decimal: '254.0.0.0',
      cidr: 7,
      ipsAvailable: 33554432,
      hosts: 33554430,
    },
    {
      decimal: '252.0.0.0',
      cidr: 6,
      ipsAvailable: 67108864,
      hosts: 67108862,
    },
    {
      decimal: '248.0.0.0',
      cidr: 5,
      ipsAvailable: 134217728,
      hosts: 134217726,
    },
    {
      decimal: '240.0.0.0',
      cidr: 4,
      ipsAvailable: 268435456,
      hosts: 268435454,
    },
    {
      decimal: '224.0.0.0',
      cidr: 3,
      ipsAvailable: 536870912,
      hosts: 536870910,
    },
    {
      decimal: '192.0.0.0',
      cidr: 2,
      ipsAvailable: 1073741824,
      hosts: 1073741822,
    },
    {
      decimal: '128.0.0.0',
      cidr: 1,
      ipsAvailable: 2147483648,
      hosts: 2147483646,
    },
    {
      decimal: '0.0.0.0',
      cidr: 0,
      ipsAvailable: 4294967296,
      hosts: 4294967294,
    },
  ];

  typesOfItems: string[] = ['INTERNET', 'INSTALACION', 'PRODUCTO', 'OTROS'];

  httpMethods: HttpMethod = {
    get: 'GET',
    post: 'POST',
    put: 'PUT',
    delete: 'DELETE',
  };

  status: Status = {
    active: 'ACTIVO',
    inactive: 'INACTIVO',
    deleted: 'ELIMINADO',
  };

  modalStatus: ModalStatus = {
    opened: 1,
    closed: 0,
    waiting: -1,
  };

  constructor() {}

  getNetMask(cidr: number): NetMask | null {
    const netMask = this.netMasks.find(netMask => netMask.cidr === cidr);

    return netMask ? netMask : null;
  }

  getBroadcast(network: string, hosts: number): string {
    const ipInt = Number(this.ip2int(network)) + hosts + 1;
    return this.int2ip(ipInt);
  }

  obtenerIpv4Disponible(lista_ipv4: Array<any>, network: number): string {
    let ipv4_automatico;
    let lista_total_ipv4 = [];
    let lista_ipv4_disponibles = [];
    let lista_ipv4_ocupados = [];

    for (let i = 2; i < 255; i++) {
      // i = 1 porque el 0 está reservado para el nerwork y el 255 para el broadcast
      lista_total_ipv4[i] = network + i;
    }

    for (let i = 0; i < lista_ipv4.length; i++) {
      lista_ipv4_ocupados[i] = lista_ipv4[i].ipv4;
    }

    lista_ipv4_disponibles = this.removeFromArray(
      lista_total_ipv4,
      lista_ipv4_ocupados,
    );

    ipv4_automatico = this.int2ip(lista_ipv4_disponibles[0]);

    return ipv4_automatico;
  }

  getIpv4Automatico(
    ipv4Ocupados: number[],
    network: number,
    gateway: number,
  ): string {
    const ipv4Utilizables = this.getIpv4Utilizables(network, gateway);
    const ipv4Disponibles = this.getIpv4Disponibles(
      ipv4Utilizables,
      ipv4Ocupados,
    );

    return this.int2ip(ipv4Disponibles[0]);
  }

  getIpv4Utilizables(network: number, gateway: number): number[] {
    const ipv4Utilizables = [];
    // i = 1 porque el 0 está reservado para el nerwork y el 255 para el broadcast
    for (let i = 1; i < 255; i++) {
      if (network + i != gateway) {
        ipv4Utilizables.push(network + i);
      }
    }
    return ipv4Utilizables;
  }

  getIpv4Disponibles(
    ipv4_utilizables: number[],
    ipv4_ocupados: number[],
  ): number[] {
    return ipv4_utilizables.filter(value => !ipv4_ocupados.includes(value));
  }

  // Función para eliminar un array de datos de un array mas grande
  removeFromArray(original: any[], remove: any[]): any[] {
    return original.filter(value => !remove.includes(value));
  }

  // Función para convertir una IPv4 Decimal a un String
  int2ip(ipInt: number): string {
    if (ipInt && ipInt != 0) {
      return (
        (ipInt >>> 24) +
        '.' +
        ((ipInt >> 16) & 255) +
        '.' +
        ((ipInt >> 8) & 255) +
        '.' +
        (ipInt & 255)
      );
    }
    return '';
  }

  // Función para convertir una IPv4 String a un Decimal
  ip2int(ip: string): number | null {
    if (ip && ip != '') {
      return (
        ip.split('.').reduce(function (ipInt, octet) {
          return (ipInt << 8) + parseInt(octet, 10);
        }, 0) >>> 0
      );
    } else {
      return null;
    }
  }

  // Asignar valores null a los elementos de un objeto que contengan como valores: '' o 'null'
  asignarCamposNulos(obj: any) {
    for (var key in obj) {
      if (
        obj[key] != null &&
        (obj[key].toString().replace(/\s+/g, '') == '' ||
          obj[key].toString().replace(/\s+/g, '') == 'null')
      ) {
        obj[key] = null;
      }
    }
    return obj;
  }

  separarCoordenadas(value: string) {
    const obj: any = {
      latitud: null,
      longitud: null,
    };

    if (value != '') {
      value = value.replace(/\s+/g, ''); // limpiar espacios en blanco
      const coordenadas = value.split(','); // separar coordenadas
      obj.latitud = coordenadas[0];
      obj.longitud = coordenadas[1];
    }

    return obj;
  }

  //Convertir un objeto en formato snake_case a camelCase y viceversa
  snakeToCamel(obj: any): any {
    const snakeToCamel = (str: string) =>
      str.replace(/(_\w)/g, k => k[1].toUpperCase());
    return Object.entries(obj).reduce(
      (x: any, [k, v]) => ((x[snakeToCamel(k)] = v), x),
      {},
    );
  }

  camelToSnake(obj: any): any {
    //const camelToSnak = str => str.replace(/[A-Z]/g, m => '_' + m.toLowerCase());
    const camelToSnak = (str: string) =>
      str.replace(/([A-Z])/g, '_$1').toLowerCase();
    return Object.entries(obj).reduce(
      (x: any, [k, v]) => ((x[camelToSnak(k)] = v), x),
      {},
    );
  }

  getNetworkString(ipv4: string): string {
    const arr = ipv4.split('.');
    const network = `${arr[0]}.${arr[1]}.${arr[2]}.0`;
    return network;
  }

  getNetworkInt(ipv4: number): number | null {
    const arr = this.int2ip(ipv4).split('.');
    const network = `${arr[0]}.${arr[1]}.${arr[2]}.0`;
    return this.ip2int(network);
  }

  getLocationByUbigeo(ubigeoCode: string) {
    type Location = {
      dapartamentoId: string;
      provinciaId: string;
      distritoId: string;
    };

    let location: Location = {
      dapartamentoId: '',
      provinciaId: '',
      distritoId: '',
    };

    if (ubigeoCode.length == 6) {
      location.dapartamentoId = ubigeoCode.slice(0, -4);
      location.provinciaId = ubigeoCode.slice(0, -2);
      location.distritoId = ubigeoCode;
    } else if (ubigeoCode.length == 4) {
      location.dapartamentoId = ubigeoCode.slice(0, -2);
      location.provinciaId = ubigeoCode;
    } else if (ubigeoCode.length == 2) {
      location.dapartamentoId = ubigeoCode;
    }
    return location;
  }

  getDateISO(date: Date): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  getNewDate(date: string): Date {
    const arr = date.split('-');
    return new Date(+arr[0], +arr[1] - 1, +arr[2]);
  }

  getMonth(date: string): number {
    return this.getNewDate(date).getMonth() + 1;
  }

  getFullYear(date: string): number {
    return this.getNewDate(date).getFullYear();
  }

  getLastDayOfTheMonth(date: string): Date {
    const newDate = this.getNewDate(date);
    return new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
  }

  getBeginningAndEndOfTheMonth(date: Date): DateRange {
    const dateISO = this.getDateISO(date);
    const firstDayOfTheMonth = this.getDateISO(
      this.getFirstDayOfTheMonth(dateISO),
    );
    const lastDayOfTheMonth = this.getDateISO(
      this.getLastDayOfTheMonth(dateISO),
    );

    return {
      startDate: firstDayOfTheMonth,
      finishDate: lastDayOfTheMonth,
    };
  }

  getLastDayOfTheMonthToString(date: string): string {
    const newDate = this.getNewDate(date);
    const finalDate = new Date(
      newDate.getFullYear(),
      newDate.getMonth() + 1,
      0,
    );
    const lastDayOfTheMonth =
      finalDate.getFullYear() +
      '-' +
      (finalDate.getMonth() + 1) +
      '-' +
      finalDate.getDate();

    return lastDayOfTheMonth;
  }

  getFirstDayOfTheMonth(date: string): Date {
    const newDate = this.getNewDate(date);
    return new Date(newDate.getFullYear(), newDate.getMonth(), 1);
  }

  getStartOfMonth(month: number) {
    const date = new Date();
    return new Date(date.getFullYear(), month - 1, 1);
  }

  getEndOfTheMonth(month: number) {
    const date = new Date();
    return new Date(date.getFullYear(), month, 0);
  }

  getFirstReceiptAmount(
    startDate: string,
    amount: number | null | undefined,
  ): number {
    const firstDay = this.getNewDate(startDate).getDate();
    const lastDay = this.getLastDayOfTheMonth(startDate).getDate();

    const amountValue: number = amount ? +amount : 0;
    const ratio = (amountValue / lastDay).toFixed(2);
    const firstAmount = Number(ratio) * (lastDay - firstDay);

    if (this.isStartTheMonth(startDate)) {
      return amountValue;
    }

    return Math.round(Number(firstAmount.toFixed(2)));
  }

  getLastReceiptAmount(finishDate: string, amount: number): number {
    const totalDays = this.getLastDayOfTheMonth(finishDate).getDate();
    const firstDay = this.getFirstDayOfTheMonth(finishDate).getDate();
    const lastDay = this.getNewDate(finishDate).getDate();
    const ratio = (amount / totalDays).toFixed(2);
    const lastAmount = Number(ratio) * (lastDay - firstDay);

    return Math.round(Number(lastAmount.toFixed(2)));
  }

  getReceiptAmount(
    startDate: string,
    finishDate: string,
    amount: number,
  ): number {
    const totalDays = this.getLastDayOfTheMonth(finishDate).getDate();
    const firstDay = this.getNewDate(startDate).getDate();
    const lastDay = this.getNewDate(finishDate).getDate();
    const ratio = (amount / totalDays).toFixed(2);
    const lastAmount = Number(ratio) * (lastDay - firstDay);

    return Math.round(Number(lastAmount.toFixed(2)));
  }

  isEqualMonths(firstDate: Date, secondDate: Date): boolean {
    return firstDate.getMonth() === secondDate.getMonth();
  }

  isEndOfTheMonth(date: string) {
    const currentData = this.getNewDate(date);
    const endOfTheMonth = this.getLastDayOfTheMonth(date);
    console.log('comparar', currentData, endOfTheMonth);
    if (currentData.getTime() === endOfTheMonth.getTime()) {
      return true;
    }
    return false;
  }

  isStartTheMonth(date: string) {
    const currentData = this.getNewDate(date);
    const endOfTheMonth = this.getFirstDayOfTheMonth(date);
    console.log('comparar', currentData, endOfTheMonth);
    if (currentData.getTime() === endOfTheMonth.getTime()) {
      return true;
    }
    return false;
  }
}
